import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'app/components';
import { CaretLeft, CloudArrowUp, File } from '@phosphor-icons/react';
import  FileComponent  from './fileComponent';

const UploadModal = ({
  isOpen,
  onClose,
  uploadTitle,
  uploadFileName,
  onSubmit,
  reuploadText,
}) => {
  const [file, setFile] = useState(null);
  const [uploadError, setUploadError] = useState('');

  const fileInputRef = useRef(null);

  useEffect(() =>{
    if(isOpen){
      setFile(null);
      setUploadError('');
    }
  },[isOpen])

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file && ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type)) {
      setFile(file);
      setUploadError('');
    } else {
      setFile(null);
      setUploadError('Please upload a valid file (PDF, JPEG, OR PNG).');
    }
  };
  const handleSubmit = () => {
    if (file) {
      onSubmit(file);
    }
  };
  const handleReupload = (e) => {
    setFile(null);
    if (e.target.files && e.target.files[0]) {
      handleFileChange(e);
    }
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  
  return (
    <div>
      <Modal
        size="regular"
        isOpen={isOpen}
        onClose={onClose}
        className="gst-upload-modal"
        title=<div className="flex items-center gap-3 heading-24">
          <div className="bg-grey-10 p-2 rounded-full w-fit">
            <CaretLeft size={16} onClick={onClose} />
          </div>
          <div
            className="flex-1 break-words whitespace-normal leading-snug"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {uploadTitle}
          </div>
        </div>
        children=<div className="flex flex-col w-full h-full gap-6 px-4 py-6 md:px-8 md:py-4">
          <div className="flex-1 w-full">
            {!file ? (
              <div
                className="w-full min-h-[160px] flex flex-col justify-center items-center gap-4 p-6 border border-grey-30 border-dashed rounded-lg"
                onClick={triggerFileInput}
              >
                <CloudArrowUp size={20} />
                <div className="heading-16 text-center flex flex-col gap-1">
                  {uploadFileName}{' '}
                  <span className="text-12 text-grey-70">PDF, JPEG or PNG only</span>
                </div>
                <>
                  <input
                    type="file"
                    hidden
                    accept="image/jpeg, image/png,image/jpg, .pdf"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                  {uploadError && <div className="text-red-400 mt-2">{uploadError}</div>}
                </>
              </div>
            ) : (
              <div className="flex flex-col items-start w-full gap-4">
                <div className="w-full">
                  <FileComponent onDelete={() => setFile(null)} className="w-full py-4 px-4 md:py-10 md:px-5" file={file} />
                </div>
                <input
                  type="file"
                  accept="image/jpeg, image/png,.pdf"
                  hidden
                  onChange={handleReupload}
                  ref={fileInputRef}
                />
                <Button
                  type="tertiary-text"
                  children=<div className="label-14">{reuploadText}</div>
                  className="mt-0"
                  onClick={triggerFileInput}
                />
              </div>
            )}
          </div>

          <div className="w-full">
            <Button
              type="primary-black"
              children="Submit"
              disabled={!file}
              onClick={handleSubmit}
              className="w-full md:w-auto"
            />
          </div>
        </div>
      />
    </div>
  );
};

export default UploadModal;
